import * as T from './loyaltyRewardsTypes';
import type { LoyaltyRewardsState } from './loyaltyRewardsTypes';
import type { LoyaltyRewardsAction } from './loyaltyRewardsActions';

const initialState: LoyaltyRewardsState = {
  rewards: [],
  loading: false,
  saving: false,
  error: null,
  rewardsLastFetchedAt: null,
};

export default function loyaltyRewardsReducer(
  state = initialState,
  action: LoyaltyRewardsAction,
): LoyaltyRewardsState {
  switch (action.type) {
    case T.FETCH_REWARDS_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_REWARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        rewards: action.payload.rewards,
        rewardsLastFetchedAt: new Date().toISOString(),
      };
    case T.FETCH_REWARDS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.FETCH_REWARD_DETAIL_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_REWARD_DETAIL_SUCCESS: {
      const reward = action.payload;
      const exists = state.rewards.some((r) => r.reward_id === reward.reward_id);
      return {
        ...state,
        loading: false,
        rewards: exists
          ? state.rewards.map((r) => (r.reward_id === reward.reward_id ? reward : r))
          : [...state.rewards, reward],
      };
    }
    case T.FETCH_REWARD_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.UPDATE_REWARD_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_REWARD_SUCCESS:
      return {
        ...state,
        saving: false,
        rewards: state.rewards.map((r) =>
          r.reward_id === action.payload.rewardId ? { ...r, ...action.payload.reward } : r,
        ),
      };
    case T.UPDATE_REWARD_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.CLEAR_REWARDS_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
}
